import { NetworkDeviceStateEvent } from '@ubie/mqttcommunication';
import { Observable, share, Subject } from 'rxjs';
import { UbieState } from '../interfaces';
import { UbieDeviceCommunicationResult } from './UbieDeviceCommunicationResult';

export class NetworkDeviceCommunicationResult extends UbieDeviceCommunicationResult {
  constructor(
    ubieDeviceCom: Subject<UbieState>,
    networkDeviceCom: Subject<NetworkDeviceStateEvent>,
  ) {
    super(ubieDeviceCom);

    this.networkDeviceState$ = networkDeviceCom.asObservable().pipe(share());
  }

  readonly networkDeviceState$: Observable<NetworkDeviceStateEvent>;
}
